import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { BackButton } from 'components'
import { useParams } from 'react-router-dom'
import { PageTitle } from 'context/PageTitleContext'
import { IconBuilding, IconPencil } from '@tabler/icons-react'
import EditClientPage from './EditClientPage'
import { getClientById } from 'services/clients.svc'
import './Edit.scss'

export default function Edit() {
  const { companyId } = useParams()
  const { data, isLoading } = useQuery(['editCompany', companyId], () =>
    getClientById(companyId),
  )

  return (
    <div className="ec-root">
      <PageTitle title="Edit Company" />

      {/* ── Hero banner ─────────────────────────────────────────────── */}
      <div className="ec-hero">
        <div className="ec-hero-inner">
          <div className="ec-hero-left">
            {data?.image?.url ? (
              <img
                src={data.image.url}
                alt={`${data.name} logo`}
                className="ec-hero-logo"
              />
            ) : (
              <div className="ec-hero-logo-placeholder">
                <IconBuilding size={28} stroke={1.5} />
              </div>
            )}
            <div className="ec-hero-body">
              <h1 className="ec-hero-name">{data?.name || '—'}</h1>
              <div className="ec-hero-subtitle">
                <IconPencil size={13} stroke={1.8} />
                Editing company information
              </div>
            </div>
          </div>
          <BackButton />
        </div>
      </div>

      {/* ── Body ────────────────────────────────────────────────────── */}
      <div className="ec-content">
        {isLoading ? (
          <div className="ec-loading">Loading, please wait…</div>
        ) : data ? (
          <EditClientPage companyId={companyId} clientDetail={data} />
        ) : (
          <div className="ec-loading">Something went wrong :(</div>
        )}
      </div>
    </div>
  )
}
